import { useNavigate } from 'react-router-dom';
import { Flex } from '@chakra-ui/react';
import { Banner, OutlineCard, Button } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faCheck } from '@fortawesome/pro-regular-svg-icons';
import { useAdjudicationRequest } from 'src/api/commands';
import { useAdjudicationData } from 'src/contexts/AdjudicationDataProvider';
import { InvitationMessage } from '../Assessment/InvitationMessage';

const AdjudicationInvitation: React.FC<{}> = () => {
  const navigate = useNavigate();

  const {
    adjudication,
    submissionId,
    submissionContext,
    invalidateAdjudicationContextData,
    organizationId
  } = useAdjudicationData();

  const {
    caseData: { acceptance, editorialRequest }
  } = adjudication;

  // Peer Review Accept Invitation Mutations
  const queryKey = ['adjudication-data', { id: adjudication.id }];
  const acceptAdjudicationRequestMutation = useAdjudicationRequest({
    submissionId,
    organizationId,
    adjudicationId: adjudication.id,
    submissionContextId: submissionContext.id,
    queryKey,
    subtype: 'accept'
  });

  const declineAdjudicationRequestMutation = useAdjudicationRequest({
    submissionId,
    organizationId,
    adjudicationId: adjudication.id,
    submissionContextId: submissionContext.id,
    queryKey,
    subtype: 'decline'
  });

  const acceptInvitation = async () => {
    await acceptAdjudicationRequestMutation.mutateAsync();
    invalidateAdjudicationContextData();
  };

  const declineInvitation = async () => {
    await declineAdjudicationRequestMutation.mutateAsync();
    invalidateAdjudicationContextData();
    navigate(`/app/adjudications?status=active-adjudications`);
  };

  return (
    <Flex>
      {(!acceptance || acceptance === 'decline') && (
        <OutlineCard borderless padding={4} width="100%">
          <Flex flexDirection="column" gap={4}>
            {acceptance === 'decline' ? (
              <Banner
                variant="error"
                heading="You have declined this invitation"
                content="We appreciate your consideration and hope to collaborate on future opportunities. No further action is required on your part for this review process."
              />
            ) : (
              <>
                <InvitationMessage editorialRequest={editorialRequest} />
                <Flex justifyContent="flex-end" gap={2} marginTop={6}>
                  <Button
                    size="context"
                    variant="caution"
                    onClick={declineInvitation}
                    disabled={acceptAdjudicationRequestMutation.isLoading}
                  >
                    <FontAwesomeIcon icon={faBan} />
                    Decline
                  </Button>
                  <Button
                    size="context"
                    variant="primary"
                    onClick={acceptInvitation}
                    isLoading={acceptAdjudicationRequestMutation.isLoading}
                    isDisabled={acceptAdjudicationRequestMutation.isLoading}
                    disabled={acceptAdjudicationRequestMutation.isLoading}
                  >
                    <FontAwesomeIcon icon={faCheck} />
                    Accept
                  </Button>
                </Flex>
              </>
            )}
          </Flex>
        </OutlineCard>
      )}
    </Flex>
  );
};

export default AdjudicationInvitation;
